const FALLBACK = {
  sans: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  ink: '#012B4F',
  muted: '#4a5c78',
};

function readRootToken(name, fallback) {
  if (typeof document === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}

function findWebFontImportUrls() {
  if (typeof document === 'undefined') return [];
  const urls = [];
  Array.from(document.styleSheets).forEach((sheet) => {
    let rules;
    try {
      rules = sheet.cssRules;
    } catch (e) {
      return;
    }
    Array.from(rules || []).forEach((rule) => {
      if (rule.type === CSSRule.IMPORT_RULE && /fonts\.googleapis\.com/.test(rule.href)) {
        urls.push(rule.href);
      }
    });
  });
  return Array.from(new Set(urls));
}

/**
 * Global typography tokens from index.css, for standalone documents (popups, srcdoc)
 * that cannot inherit CSS custom properties from the app.
 */
export function getGlobalTypography() {
  return {
    sans: readRootToken('--font-sans', FALLBACK.sans),
    ink: readRootToken('--text-ink', FALLBACK.ink),
    muted: readRootToken('--text-muted', FALLBACK.muted),
    fontLinksHtml: findWebFontImportUrls()
      .map((href) => `<link rel="stylesheet" href="${href}">`)
      .join(''),
  };
}
